<template>
  <div class="promotionsList">
    <loading v-if="!showContent"></loading>
    <div class="row">
      <div class="col-md-12">
        <h1 class="titulo">Promoção</h1>
      </div>
      <div class="promocao_detalhada promocoes">
        <div class="col-md-3">
          <img v-if="item.image" :src="item.image" class="imagem-destaque"/>
          <div class="socialShare">
            <span> Clique e compartilhe: </span>
            <social-sharing :url="currentUrl"
                            :quote="title"
                            inline-template>
              <div>
                <network network="facebook">
                  <i class="fab fa-facebook-f"></i>
                </network>
                <network network="googleplus">
                  <i class="fab fa-google-plus-g"></i>
                </network>
                <network network="twitter">
                  <i class="fab fa-twitter"></i>
                </network>
              </div>
            </social-sharing>
          </div>
        </div>
        <div class="col-md-9">
          <ul>
            <li><h3>{{ title }}</h3></li>
            <li class="texto" v-html="item.description"></li>
            <li>
              <span>
                <i aria-hidden="true" class="fa fa-calendar"></i> Fim: {{ item.dateFinish }}
                <i aria-hidden="true" class="fa fa-clock-o"></i> {{ item.houtFinish }}
              </span>
            </li>
          </ul>
        </div>
        <div class="col-md-12">
          <div class="form-content">
            <form>
              <label>
                Nome:
                <input type="text" v-model="nome">
              </label>
              <label>
                Email:
                <input type="text" v-model="email">
              </label>
              <label>
                Telefone:
                <input type="text" v-model="telefone">
              </label>
              <vue-recaptcha ref="recaptcha" @verify="onVerify" @expired="onExpired" :sitekey="sitekey" class="captcha">
              </vue-recaptcha>
              <button class="btn_enviar" type="button" @click="callback()"> Enviar</button>
            </form>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>

  import {get, post} from '../helpers/api';
  import Loading from '../components/common/Loading.vue';
  import SocialSharing from 'vue-social-sharing';
  import VueRecaptcha from 'vue-recaptcha';

  export default {
    name: "PromotionDetails",
    components: {
      Loading,
      SocialSharing,
      VueRecaptcha
    },
    data() {
      return {
        title: 'Promoção',
        showContent: false,
        item: [],
        promocaoId: '',
        nome: '',
        email: '',
        telefone: '',
        captcha: '',
        sitekey: window.config.RECAPTCHA_KEY,
        currentUrl: ''
      }
    },
    activated() {
      this.initialize()
    },
    created() {
      this.currentUrl = window.location.href;
      this.initialize()
    },
    methods: {
      initialize() {
        let self = this;
        self.showContent = false;
        get('promotion/' + this.$route.params.id).then(function (response) {
          self.item = response.data.result.data;
          self.showContent = true;
          self.title = self.item.name;
        });
      },
      onSubmit: function () {
        this.$refs.recaptcha.execute();
      },
      onVerify: function (response) {
        this.captcha = response;
      },
      onExpired: function () {
      },
      resetRecaptcha() {
        this.$refs.recaptcha.reset() // Direct call reset method
      },
      callback() {
        let self = this;
        // google recaptcha token , then you can pass to backend with your form data .
        if (!this.nome) {
          swal({
            title: "O campo nome é obrigatório.",
            icon: "warning",
          });
          return false;
        }
        if (!this.email) {
          swal({
            title: "O campo email é obrigatório.",
            icon: "warning",
          });
          return false;
        }
        if (!this.telefone) {
          swal({
            title: "O campo telefone é obrigatório.",
            icon: "warning",
          });
          return false;
        }

        if (!this.captcha) {
          swal({
            title: "Favor marcar captcha.",
            icon: "warning",
          });
          return false;
        }

        swal({
          text: 'Carregando...',
          buttons: false,
        });
        post('request-form-promotion', {
          nome: this.nome,
          email: this.email,
          telefone: this.telefone,
          promocao_id: self.item.id
        }).then(function () {
          swal({
            title: "Cadastrado com sucesso.",
            icon: "success",
          });
          self.clearForm();
          self.resetRecaptcha()
        }).catch(function () {
          self.showContent = true;
          self.resetRecaptcha()
          swal({
            title: "Ocorreu um erro, tente novamente mais tarde.",
            icon: "error",
          });
        });

      },
      clearForm() {
        this.nome = '';
        this.email = '';
        this.telefone = '';
      },
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/PromotionDetails.vue